import React from 'react';
var Label = function (props) {
    var htmlFor = props.htmlFor, inlineForm = props.inlineForm, children = props.children;
    return (React.createElement("label", { className: inlineForm ? 'mr-3' : '', htmlFor: htmlFor }, children));
};
export default Label;
